import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import { api } from './api';
import type { Channel } from './types';

type ChannelsCtx = {
  channels: Channel[];
  refresh: () => Promise<void>;
};

const Ctx = createContext<ChannelsCtx>({ channels: [], refresh: async () => {} });

// アプリ全体で channels を 1 か所に集約。Admin の追加/編集/削除後に refresh() を呼べば
// サイドバーやアップロード画面のチャンネル選択が即時更新される。
export function ChannelsProvider({ children }: { children: ReactNode }): JSX.Element {
  const [channels, setChannels] = useState<Channel[]>([]);
  const refresh = useCallback(async () => {
    try {
      const cs = await api.listChannels();
      setChannels(cs);
    } catch {
      setChannels([]);
    }
  }, []);
  useEffect(() => {
    void refresh();
  }, [refresh]);
  return <Ctx.Provider value={{ channels, refresh }}>{children}</Ctx.Provider>;
}

export function useChannels(): ChannelsCtx {
  return useContext(Ctx);
}
